<div *ngIf="cartCount>0" class="page-layout blank fullwidth">
    
    
    <!-- <mat-progress-bar class="mt-8" *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
    <div class="cart mt-8 p-8"> 
        <div class="top-heading">
            <div style="display: flex;">
                <i (click)="goBack()" class="go-back" style="color: black;font-weight: bold; cursor: pointer;">arrow_back</i>           
                <h2 class="cart-title" *ngIf="!redeemCart">My Cart</h2>
                <h2 class="cart-title" *ngIf="redeemCart">Rewards Cart</h2>
                <div class="saved-label" *ngIf="!redeemCart">SAVED ₹{{sparesDiscount | number:'1.2-2'}}</div>
            </div>
            <div class="share-cart-icon-and-text" *ngIf="!redeemCart">
                <span *ngIf="!isMobile">SHARE CART</span>
              <mat-icon class="share-icon" (click)="shareCartViaWhatsApp()">share</mat-icon> 
            </div>
        </div>
        <div class="cart-left">
            <div *ngIf=" variant1" class="vehicle-details-sec cart-card">
                <div class="make-sec">
                    <img 
                    [src]="'https://cube.getpitstop.com/assets/img/' + make1.toLowerCase().replace(' ', '') + '.png'" 
                    alt="Make Image"
                    class="img-fluid make-image"
                  >
                </div>
                <div class="model-sec">
                   <p> {{model1}},{{fuelType}}</p>
                <!-- </div>
                <div class="year-sec"> -->
                <!-- </div>
                <div class="variant-sec"> -->
                    <p></p>
                <!-- </div> 
                <div class="variant-sec"> -->
                    <p>  {{variant1}},[{{year1}}]</p>
                <!-- </div> 
                <div class="variant-sec" *ngIf="registrationNumber"> -->
                    <p>{{registrationNumber}}</p>
                </div> 
            </div>

            <div *ngIf="vehicleType=='universal' && !make" class="vehicle-details-sec cart-card">
                <div class="universal-make-sec">
                    <mat-icon style="font-size: 35px;"> directions_car</mat-icon>
                </div>
                <div class="model-sec universal-sec">Universal</div>                              
            </div>
            <!-- <div class="location-sec">
                <div class="cart-card"> 
                    <div class="location-icon"><mat-icon> location_on</mat-icon></div>
                    <div class="location-content">
                        <div class="location-title">Location</div>
                        <div class="location-details">
                            {{shippingAddress}}
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div style="margin-top: 7px; margin-bottom: 24px;" *ngIf="make">
                <div class="logo-container"  >
                  <div class="logo">
                  <img 
                      [src]="'https://cube.getpitstop.com/assets/img/' + make.toLowerCase().replace(' ', '') + '.png'" 
                      alt="Make Image"
                    >
                  </div>
                </div>
          
            <div class="model-sec" style="width:80%;line-height: 2.4px;" >
              <p style="font-weight:bold">{{model}}, {{fuelType}}</p>
              <p>{{variant}} [{{year}}]</p>
              <p style="margin-bottom: -10px;"  *ngIf="registrationNumber">{{registrationNumber}}</p>
          </div>
        </div> -->

            <div class="spares-added-sec cart-card" style="padding-top: 8px;">
                <div class="spares-added-title" >
                    <div class="spares-count">{{cartCount}}</div>
                    <h4>Spares Added</h4>
                </div>
                <div class="add-more-sec" *ngIf="selectedTab === 'savings'">
                    <button mat-button (click)="addMore()">Add more</button>
                </div>
            </div>  

            <div class="spares-added" *ngFor="let cart of cartList">
                <div class="cart-card mt-8 cart-instock"> 
                    <div class="spares-part"> 
                        <div class="offer-tag-cart"*ngIf="cart?.mrp > 0 && !redeemCart">
                            <!-- {{ ((cart?.discount / cart?.mrp) * 100).toFixed(0) + '%' }} Off -->
                            {{ cart?.discount?.toFixed(0) }}% Off
                        </div>
                        <!-- <div class="offer" style="text-align: left;" *ngIf="data.discount>0">{{discountType}} off</div> -->
                        <img *ngIf="cart.imageUrl" class="img-fluid part-image" src="{{cart.imageUrl}}" alt=""/>
                        <img *ngIf="!cart.imageUrl" class="img-fluid part-image" src="../../../../assets/images/logos/logo.png" alt="" />
                    </div>
                    <div class="spare-details-sec">
                        <div class="spare-part-name">{{cart.name}}</div>
                        <div class="spare-brand">{{cart.brand.name}}</div>
                        <div class="spare-part-number">{{cart.partNumber}}</div>
                        <div class="spare-price" *ngIf="cart.discount>0; else onlyMRP">
                            <span class="selling-price">&#8377;{{cart.sellingPrice *cart.cart_qty | number:'1.2-2'}}</span>
                            <span class="mrp-price">&#8377;{{cart.mrp * cart.cart_qty| number:'1.2-2'}}</span>
                            <!-- {{cart.discount * cart.cart_qty | number:'1.2-2'}} -->
                            <div class="discount-price">You save &#8377;{{(cart.mrp - cart.sellingPrice) * cart.cart_qty | number:'1.2-2'}}</div>
                        </div>
                        <ng-template #onlyMRP>
                            <div class="spare-price-mrp">
                                &#8377;{{cart.mrp * cart.cart_qty}}
                            </div>
                        </ng-template>
                    </div>
                    <!-- <div class="spare-add-cart" (click)="removeItem(cart.name)">
                        <mat-icon>delete_sweep</mat-icon>
                    </div>  -->
                    <div class="spare-add-cart" *ngIf="selectedTab === 'savings'">
                        <div class="btn-group">
                            <button mat-raised-button (click)="removeItem(cart.cart_qty, cart.key)"><mat-icon>remove</mat-icon></button> 
                            <input type="text" class="part-count" [(ngModel)]="cart.cart_qty" readonly>
                            <button mat-raised-button (click)="addItem(cart.cart_qty, cart.key)"><mat-icon>add</mat-icon></button> 
                        </div>
                    </div>
                    <div class="spare-add-cart" *ngIf="selectedTab === 'mega-savings'">
                        <div class="btn-group">
                            <button mat-raised-button (click)="removeItem(cart.cart_qty, cart.keyOem)"><mat-icon>remove</mat-icon></button> 
                            <input type="text" class="part-count" [(ngModel)]="cart.cart_qty" readonly>
                            <button mat-raised-button (click)="addItem(cart.cart_qty, cart.keyOem)"><mat-icon>add</mat-icon></button> 
                        </div>
                    </div>
                </div>
            </div>
            <!-- ORDER INSTRUCTIONS -->
           <div class="oi-card" *ngIf="roleType === 'autoverse_employee'" (click)="openOrderInstructions()">
                <div class="oi-card-header">
                    <div class="oi-left">
                    <span class="oi-icon">📝</span>
                    <div class="oi-title-header">
                        <span class="oi-title">Add Instructions for Autoverse Team</span>
                        <div class="oi-subtext"> Optional • Helps us serve you better </div>
                    </div>
                    </div>
                    <span class="oi-arrow" (click)="openOrderInstructions()"><mat-icon>keyboard_arrow_right</mat-icon></span>
                </div>
            </div>
        </div>
        <div class="cart-right">
            <div class="tab-toggle" *ngIf="hasMegaSavings && !redeemCart">
                <button 
                    [class.active]="selectedTab === 'savings'" 
                    (click)="selectTab('savings')">
                    Savings
                </button>
                <button 
                    [class.active]="selectedTab === 'mega-savings'" 
                    (click)="selectTab('mega-savings')">
                    Mega Savings
                </button>
            </div>
            <div  *ngIf="hasMegaSavings && (megaDiscount - cartDiscount) > 0">
                <div
                    *ngIf="showSavingsBanner"
                    class="tooltip-banner"
                    (click)="switchToMegaSavings()"
                    >
                <div class="tooltip-content">
                    <span class="tooltip-text" >
                    Save ₹{{ megaDiscount-cartDiscount | number:'1.2-2'}} more on this order by selecting
                    <strong>Mega Savings</strong>
                    </span>
                <i
                    class="material-icons close-circle-icon"
                    (click)="closeBanner()"
                    aria-label="Close"
                    >
                close
                </i>
                    </div>
                <div class="tooltip-arrow"></div>
                </div>
            </div>
            <div class="discount-sec" *ngIf="sparesDiscount>0">
                <p>You have saved  &#8377;{{sparesDiscount | number:'1.2-2'}} on this order</p>
            </div>
            <div #target  class="price-details-sec" [@shakeit]="this.states['shake']" (@shakeit.done)="shakeEnd('shake', $event)">
                <div class="cart-card"> 
                    <div class="price-details-title">Price Details</div>

                    <div class="price-details">
                        <div class="price-details-left">Spares Total</div>
                        <div class="price-details-right">&#8377;{{cartSubTotal | number:'1.2-2'}}</div>
                    </div>

                    <!-- Spares Discount -->
                    <div class="price-details" *ngIf="sparesDiscount>0">
                        <div class="price-details-left">Spares Discount</div>
                        <div class="price-details-right" id="discount">- &#8377;{{sparesDiscount | number:'1.2-2'}}</div>
                    </div> 
                    
                    <div *ngIf="!redeemCart">
                     <div class="price-details" *ngIf="(cartSubTotal-sparesDiscount) > avoidShippingCharges">
                        <div class="price-details-left">Shipping Charges
                            <i style="cursor: pointer ;" class="maticon" mat-raised-button [matTooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()">
                                info_outline
                              </i>
                        </div>
                        <div class="freetag" >₹{{shippingCharges}}
                            <span class="price-details-right"  style="color: #4caf50;"> FREE</span>
                        </div>
                    </div> 
                    
                    <div class="price-details" *ngIf="shippingCharges>0">
                        <div class="price-details-left">Shipping Charges
                            <i style="cursor: pointer;" class="maticon" mat-raised-button [matTooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()">
                                info_outline
                              </i>
                        </div>
                        
                            <span class="price-details-right">₹{{shippingCharges}}</span>
                    </div> 
                    </div>

                     <div *ngIf="redeemCart">
                    <div class="price-details" >
                        <div class="price-details-left">Shipping Charges </div>
                        <div class="price-details-right" >
                            <span class="free-badge">FREE</span>
                            <!-- <span style="text-decoration: line-through">₹0</span> -->
                        </div>
                    </div>
                    
            </div>
                    <ng-template #bottomSheetTemplate >
                        <div class="bottom-sheet-content">
                            <i  class="material-icons" (click)="closeBottomSheet()" style="float: left ; cursor: pointer;">cancel</i>
                          <h3 style="font-weight: bold;">Shipping Charge</h3>
                          <p style="font-size: 13px;">Autoverse provides free Shipping for orders above {{avoidShippingCharges}}</p>
                          <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
                        </div>
                      </ng-template> 

                        
                    
                    <!-- Coupon Discount -->
                    <!-- <div class="price-details" >
                        <div class="price-details-left">Coupon Discount</div>
                        <div class="price-details-right" id="coupon-discount" (click)="couponDiscountPopup()">Apply Coupon</div>
                    </div>   -->
                                
                    <!-- Shipping Charges -->
                    <!-- <div *ngIf="isShippingCharges=='true'" class="price-details" id="shipping-charges">
                        <div class="price-details-left">Shipping Charges <mat-icon (click)="shippingChargesPopup()">info</mat-icon></div>
                        <div *ngIf="shippingChargesApplicable==true" class="price-details-right">&#8377;{{shippingCharges | number:'1.2-2'}}</div>
                        <div *ngIf="shippingChargesApplicable==false" class="price-details-right">
                            <span class="mrp-price">&#8377;{{shippingCharges | number:'1.2-2'}}</span>
                            <span id="free-shipping">FREE</span>
                        </div>
                    </div>     -->

                    <div class="price-details" id="total">
                        <div class="price-details-left">Total</div>
                        <div class="price-details-right" *ngIf="!redeemCart">&#8377;{{cartGrandTotal | number:'1.2-2'}}</div>
                        <div class="price-details-right" *ngIf="redeemCart">&#8377;{{cartSubTotal   | number:'1.2-2'}}</div>
                        

                    </div>
                </div>
                
            </div>
    
            <div class="wallet-summary" *ngIf="redeemCart">
            <h3>Wallet Payment Summary</h3>
            <p class="good-news">🎉<strong>Good news!</strong></p>
            <p *ngIf="(cartSubTotal)>walletAmount">Your wallet covers 
                <span class="wallet-amount" >₹{{walletAmount}}</span>
            </p>
            <p *ngIf="(cartSubTotal)<=walletAmount">
                Your wallet covers the full order amount.
            </p>
            <div class="pay-remaining" *ngIf="(cartSubTotal)>walletAmount">
                You just need to pay <span class="remaining-amount">₹{{(cartSubTotal) - walletAmount}}</span> to complete this order.
            </div>
            <div class="pay-remaining" *ngIf="(cartSubTotal)<=walletAmount">
               No extra payment needed.
            </div>
            </div>
        </div>  

    </div>
    <div>

    </div>
    <div *ngIf="cartList.length>0" class="payment-bottom">
        <p *ngIf="autoverseCredit==true && autoverseCreditAmt>= cartGrandTotal && !redeemCart">Eligible for payment with <img src="assets/images/logos/credit.png" class="creadit-image"></p>
        <div  class="place-order-sec">
        <div class="grand-total" *ngIf="!redeemCart">&#8377;{{cartGrandTotal | number:'1.2-2'}}</div>
        <div class="grand-total" *ngIf="redeemCart">&#8377;{{cartSubTotal   | number:'1.2-2'}}</div>
        <div class="view-details">
            <a (click)="scroll(target)">View Details</a>
        </div>
        <button class="place-order-btn" (click)="payment()" *ngIf="createorderpermission == 'true'">Place Order</button>
        
        </div>
    </div>
</div>


<!-- Empty Cart -->
<div *ngIf="cartCount==0" class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
    <div class="empty-cart">
        <img src="{{emptyImg}}" alt="" />
        <div class="sec1">No spares added yet</div>
        <div class="sec2">Your car parts are just a click away</div>
        <button mat-button [ngClass]="isMobile ? 'browse-parts-btnMobile' : 'browse-parts-btn'" (click)="browseParts()">Browse Parts</button>
    </div>
</div>

<div *ngIf="loading">
    <div #dynamicContainers></div>
</div>
<div class="overlay" [class.visible]="showBottomSheet" (click)="switchToMegaSavings()" *ngIf="showBottomSheet"></div>
    <div class="bottom-sheet" *ngIf="showBottomSheet && !redeemCart">
       <h3>Go For Mega Savings</h3>
       <i  class="close" (click)="switchToMegaSavings()">cancel</i>
        <p *ngIf="(megaDiscount - cartDiscount) > 0">Save <strong>₹{{ megaDiscount-cartDiscount | number:'1.2-2'}}</strong> more on this order by selecting <strong>Mega Savings</strong></p>
        <div class="pay">
            <button mat-flat-button color="primary" (click)="switchToMegaSavings()">
                Pay <strong>₹{{ megaSavingsTotal | number:'1.2-2'}}</strong> with <strong>Mega Savings</strong>
            </button>
            <div class="link" (click)="closeSheet()">No, I want to pay <strong> ₹{{ cartGrandTotal| number:'1.2-2' }}</strong></div>
        </div>
    </div> 
    
    <!-- =============cart shared popup======= -->
<!-- <div class="popup-overlay" *ngIf="showSharedWtemPopup">
  <div class="popup-container">
    <div class="close-h3">
        <mat-icon class="close-icon" (click)="closeSharedWtemPopup()">close</mat-icon>
        <h3 class="popup-title">Cart items shared with you!</h3>
    </div>
    <div class="popup-content">
  <div class="item-card" *ngFor="let item of cartItems">
    <div class="offer-tag" *ngIf="item.discount > 0 && item.mrp > 0">
      {{ ((item.discount / item.mrp) * 100).toFixed(0) }}% off
    </div>

    <img [src]="item.imageUrl || 'assets/images/logos/logo.png'" class="item-image" alt="item image" />

    <div class="item-info">
      <div class="item-title">{{ item.name }}</div>
      <div class="item-units">{{ item.cartQty || 1 }} Units</div>
        <div class="item-brand" *ngIf="item.brandName">{{ item.brandName }}</div>
      <div class="item-part">{{ item.partNumber }}</div>

      <div class="item-price" *ngIf="item.discount > 0; else noDiscount">
        <span class="selling-price">₹{{ item.sellingPrice | number:'1.2-2' }}</span>
        <span class="mrp-price">₹{{ item.mrp | number:'1.2-2' }}</span>
        <div class="discount-price">You save ₹{{ item.discount | number:'1.2-2' }}</div>
      </div>

      <ng-template #noDiscount>
        <div class="item-price">
          ₹{{ item.mrp | number:'1.2-2' }}
        </div>
      </ng-template>

    </div>
  </div>
</div>

       <div class="popup-actions">
      <button class="add-to-cart-btn" (click)="addSharedCartToLocalCart()">Add To Cart</button>
      <button class="cancel-btn" (click)="closeSharedWtemPopup()">Cancel</button>
    </div>
   
  </div>
</div> -->

<div *ngIf="showSharedWtemPopup">
  <app-asp-share-cart
    [cartItems]="cartItems"
    [sharedCartKey]="sharedCartKey"
    (close)="closeSharedWtemPopup()">
  </app-asp-share-cart>
</div>

<div class="oi-overlay" *ngIf="showOrderInstructionSidebar">
  <div class="oi-drawer">
    <app-asp-order-instruction-sidebar
      (close)="closeOrderInstructions()"
      (save)="handleOrderInstructionSave($event)">
    </app-asp-order-instruction-sidebar>
  </div>
</div>